import React from 'react';
import classNames from 'classnames';
import styles from './styles.scss';

export default function Checkbox({
  onClick,
  label,
  checked,
  alignSelf,
  style,
}) {
  let circleClass = styles.circle;
  if (checked) {
    circleClass = styles.circleChecked;
  }
  return (
    <div
      style={{ alignSelf, ...style }}
      onClick={() => onClick(!checked)}
      className={classNames(styles.checkbox, {
        [styles.checked]: checked,
      })}
    >
      <div className={circleClass} />
      {label && <span className={styles.label}>{label}</span>}
    </div>
  );
}
Checkbox.defaultProps = {
  checked: false,
  onClick: () => null,
  label: null,
  alignSelf: 'flex-start',
  style: {},
};
